import { useList, useTranslate } from "@refinedev/core";
import { ContactResponse } from "../types";
import { useOrganization } from "hooks/useOrganization";
import { PageLayout } from "components/PageLayout";
import { AvatarPanel } from "./components/AvatarPanel";

export const ContactListPage = () => {
  const t = useTranslate();
  const { organization } = useOrganization({});
  const { data } = useList<ContactResponse>({
    resource: `media/${organization?.id}/contacts`,
    pagination: { mode: "off" },
    queryOptions: {
      keepPreviousData: false,
      enabled: !!organization?.id,
    },
  });

  return (
    <PageLayout
      title={t("media.contacts.index.myAvatars")}
      description={t("media.contacts.index.subtitle")}
      breadcrumbLabel={t("src.App.contacts")}
    >
      <AvatarPanel
        avatars={data?.data ?? []}
        organizationId={organization?.id}
      />
    </PageLayout>
  );
};
